import FlashcardsAPI from "@/services/api/flashcards"
import { useMutation, useQueryClient } from "@tanstack/react-query"

const useDeleteFlashcard = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationKey: ["delete-flashcard"],
    mutationFn: FlashcardsAPI.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-flashcards"] })
    },
  })
  return mutation
}

export default useDeleteFlashcard
